export class DisPosition {
    id : number;
    positionCode : string;
    positionName : string;
}